import React from 'react';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { Typography } from '@guildeducationinc/recess';
import { ComponentDataKey } from '@src/components/Pages/Home/Layout/config';
import { useEmployerContent } from '@src/context/EmployerContentContext';
import { MOBILE_QUERY } from '@src/constants';
import './ProviderCallout.scss';

const ProviderCallout: React.FC = () => {
  const isMobile = useMediaQuery(MOBILE_QUERY);
  const dataKey = ComponentDataKey.STUDENT_LOAN;
  const { [dataKey]: content } = useEmployerContent() ?? {};

  const providerCalloutClassNames = classnames(
    'flex',
    'margin--top_32',
    isMobile ? 'flexDirection--column' : ['flexDirection--row', 'flexItems--center']
  );

  const providerCalloutLogoClassnames = classnames(
    isMobile
      ? ['providerCalloutLogoMobile', 'margin--bottom_8']
      : [
          'providerCalloutLogoDesktop',
          'borderColor--black-lighten-87',
          'borderWidth--right_1',
          'margin--right_16',
          'padding--right_16',
        ]
  );

  return (
    <div className={providerCalloutClassNames}>
      <img
        alt={content?.providerCallout.img.alt}
        className={providerCalloutLogoClassnames}
        src={content?.providerCallout.img.src}
      />
      <Typography variant='label2'>{content?.providerCallout.text}</Typography>
    </div>
  );
};

export default ProviderCallout;
